// frontend/shared-ui/src/components/PasswordField.jsx
import React, { useState, useMemo } from "react";

function strengthOf(pw) {
  if (!pw) return { score: 0, label: "", color: "#e5e7eb" };
  let score = 0;
  if (pw.length >= 8) score++;
  if (pw.length >= 12) score++;
  if (/[A-Z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;

  const map = [
    { label: "Very weak", color: "#dc3545" },
    { label: "Weak", color: "#f59e0b" },
    { label: "Fair", color: "#f59e0b" },
    { label: "Good", color: "#0d6efd" },
    { label: "Strong", color: "#198754" },
    { label: "Very strong", color: "#198754" },
  ];
  return { score, ...map[score] };
}

export default function PasswordField({
  label = "Password",
  value,
  onChange,
  autoComplete = "new-password",
  required = false,
  showStrength = false,
  hint,
  error,
  disabled,
  name,
}) {
  const [visible, setVisible] = useState(false);
  const strength = useMemo(() => strengthOf(value), [value]);

  return (
    <div className="fh-form-field">
      {label && (
        <label
          className={`fh-form-field__label ${required ? "is-required" : ""}`}
        >
          {label}
        </label>
      )}
      <div className="fh-password-field">
        <input
          type={visible ? "text" : "password"}
          className={`fh-input ${error ? "is-invalid" : ""}`}
          value={value ?? ""}
          onChange={(e) => onChange?.(e.target.value)}
          autoComplete={autoComplete}
          disabled={disabled}
          name={name}
        />
        <button
          type="button"
          className="fh-password-field__toggle"
          onClick={() => setVisible((v) => !v)}
          tabIndex={-1}
          aria-label={visible ? "Hide password" : "Show password"}
        >
          {visible ? "🙈" : "👁"}
        </button>
      </div>

      {showStrength && value && (
        <div className="fh-password-strength">
          <div className="fh-password-strength__bar">
            <div
              className="fh-password-strength__fill"
              style={{
                width: `${(strength.score / 5) * 100}%`,
                background: strength.color,
              }}
            />
          </div>
          <span
            className="fh-password-strength__label"
            style={{ color: strength.color }}
          >
            {strength.label}
          </span>
        </div>
      )}

      {hint && <div className="fh-form-field__hint">{hint}</div>}
      {error && <div className="fh-form-field__error">{error}</div>}
    </div>
  );
}
